import React, { FunctionComponent } from "react";
import { styled } from "styled-components";

import * as gtag from "../../utils/gtag";
import { Device } from "@/utils/device";
import { Article } from "@/types/article/Article";
import PostArticleCard from "./PostArticleCard";
import medik8ArticleAdValues from "@/utils/medik8ArticleAdValues";

interface PostFeaturedContentProps {
  articles: Article[];
}

const PostFeaturedContent: FunctionComponent<PostFeaturedContentProps> = (
  props
) => {
  const onClickArticle = () => {
    gtag.event({
      name: gtag.GA_EVENT.EDIT_ENGAGEMENT,
      category: "EDIT",
      label: "From home",
      value: "Featured",
    });
  };

  return (
    <S.Container data-cy="featured-articles-content">
      <S.FeaturedArticle>
        <PostArticleCard
          {...medik8ArticleAdValues}
          externalLink
          flexDirection="column"
          imageWidth="100%"
          onClick={() => onClickArticle()}
        />
      </S.FeaturedArticle>
      {props.articles.map((article) => (
        <PostArticleCard
          {...article}
          onClick={() => onClickArticle()}
          key={article.title}
        />
      ))}
    </S.Container>
  );
};

const S = () => {};

S.Container = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  margin: 0 0 40px 0;
  gap: 40px;
  position: relative;

  @media (min-width: ${Device.tablet}) {
    grid-template-columns: 2fr 3fr;
  }

  @media (min-width: ${Device.desktop}) {
    grid-template-columns: 1fr 1.5fr;
    margin: 0;
  }
`;

S.FeaturedArticle = styled.article`
  grid-row: 1/5;
  bottom: auto;
`;

export default PostFeaturedContent;
